import { useState } from 'react';
import { z } from 'zod';
import { supabase } from '@/integrations/supabase/client';
import { useToast } from '@/hooks/use-toast';

const emailSchema = z.string().trim().toLowerCase().email({ message: 'Please enter a valid email' }).max(255);

export const useNewsletterSubscribe = (source: string) => {
  const [email, setEmail] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const { toast } = useToast();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    const parsed = emailSchema.safeParse(email);
    if (!parsed.success) {
      toast({ title: 'Invalid email', description: parsed.error.issues[0].message, variant: 'destructive' });
      return;
    }
    setSubmitting(true);
    const { error } = await supabase
      .from('newsletter_subscribers')
      .insert({ email: parsed.data, source });
    setSubmitting(false);

    if (error) {
      // 23505 = unique violation
      if ((error as { code?: string }).code === '23505') {
        toast({ title: "You're already subscribed", description: 'This email is already on our list.' });
        setEmail('');
        return;
      }
      toast({ title: 'Subscription failed', description: 'Please try again later.', variant: 'destructive' });
      return;
    }
    // Notify info@ inbox (fire and forget, don't block UX)
    supabase.functions.invoke('send-email', {
      body: { type: 'newsletter', data: { email: parsed.data, source } },
    }).catch(() => {});
    toast({ title: 'Subscribed!', description: "Thanks — you'll hear from us soon." });
    setEmail('');
  };

  return { email, setEmail, submitting, handleSubmit };
};
